module.exports = __webpack_public_path__ + "static/media/58-gloucester.23096590.jpeg";